import { TopBarPageContainer } from "@components/PageContainer";
import { PermissionedRoutes } from "@components/PermissionedRoutes";
import { useUserConfiguration } from "@hooks/useUserConfiguration";
import { Button } from "@narmi/design_system";
import { Link, RouteObject, useNavigate, useParams } from "react-router-dom";

export const ROLES_ROUTES: RouteObject[] = [
  {
    index: true,
    async lazy() {
      const [{ Roles }, { RolesStudio }] = await Promise.all([
        import("./Roles"),
        import("./RolesStudio"),
      ]);
      return {
        Component() {
          const { permissions, features } = useUserConfiguration();
          const isStudioEnabled = features.includes("permissions_redesign");
          return (
            <TopBarPageContainer
              title="Roles"
              action={
                permissions.includes("backoffice.add_group") ? (
                  <Link to={"/roles/new"}>
                    <Button size="xs" startIcon={"plus"} label="Create a new role" />
                  </Link>
                ) : null
              }
            >
              {isStudioEnabled ? <RolesStudio /> : <Roles />}
            </TopBarPageContainer>
          );
        },
      };
    },
  },
  {
    element: <PermissionedRoutes requiredPermissions={["backoffice.add_group"]} />,
    children: [
      {
        path: "new",
        async lazy() {
          const [{ CreateRole }, { CreateRoleStudio }] = await Promise.all([
            import("./CreateRole"),
            import("./CreateRoleStudio"),
          ]);
          return {
            Component() {
              const navigate = useNavigate();
              const { features } = useUserConfiguration();
              return features.includes("permissions_redesign") ? (
                <CreateRoleStudio />
              ) : (
                <CreateRole navigateToRoles={() => navigate("/roles")} />
              );
            },
          };
        },
      },
    ],
  },
  {
    element: <PermissionedRoutes requiredFeatures={["permissions_redesign"]} />,
    children: [
      {
        path: "compare",
        async lazy() {
          const { CompareRoles } = await import("./CompareRoles");
          return { Component: CompareRoles };
        },
      },
    ],
  },
  {
    element: <PermissionedRoutes requiredPermissions={["backoffice.change_group"]} />,
    children: [
      {
        path: ":roleId",
        async lazy() {
          const [{ EditRole }, { EditRoleStudio }] = await Promise.all([
            import("./EditRole"),
            import("./EditRoleStudio"),
          ]);
          return {
            Component() {
              const navigate = useNavigate();
              const { roleId } = useParams<{ roleId: string }>();
              const { features } = useUserConfiguration();

              if (!roleId) {
                return null;
              }

              return features.includes("permissions_redesign") ? (
                <EditRoleStudio roleId={roleId} />
              ) : (
                <EditRole roleId={roleId} navigateToRoles={() => navigate("/roles")} />
              );
            },
          };
        },
      },
    ],
  },
];
